import { SuccessReturnBody, getSuccessReturnBody } from '../general';
import { Source } from '../../types/fromDb/Sources/source'

export type SourcePostRequest = Pick<Source, 'name' | 'originalName'>

export function postSourceReturnBody(body: SourcePostRequest): SuccessReturnBody {
  return getSuccessReturnBody(body)
}
